import React from 'react';
import { WidgetConfig } from '../../types';
import getResource from '../../helpers/get-resource';
import getField from '../../helpers/get-field';
import useResourceComparison from '../../../section-dashboard/hooks/widget-comparison/use-resource-comparison';
import CreateAWidgetPreviewMessage from '../../create-a-widget/components/create-a-widget-preview-message';
import useResourceBigNumberComparison from '../../../section-dashboard/hooks/widget-comparison/big-number/use-resource-big-number-comparison';
import WidgetBigNumberComparison from '../../../section-dashboard/widgets/widget-comparison/widget-big-number-comparison';

import { WidgetColour } from '../../../section-dashboard/types';

const WidgetPreviewBigNumberComparison = ({ config }: { config: WidgetConfig }) => {
    const resource = getResource(config.resource);
    const graphMetricField = config.graph_metrics && getField(config.graph_metrics);
    const widgetColor = config.widget_color;

    const resourceData = useResourceComparison({
        resource: resource,
        request: {
            isGraph: true,
            orderBy: resource ? [{ field: resource?.dateDimension, orderByDirection: 'asc' }] : [],
            groupBy: resource?.dateDimension,
            graphGroupBy: resource ? [resource?.dateDimension] : [],
            graphMetrics: graphMetricField ? [graphMetricField] : [],
            enabled: !!resource,
        },
    });

    const bigNumberData = useResourceBigNumberComparison({
        resourceData: resourceData,
        field: graphMetricField || undefined,
        aggregation: config.aggregation || 'avg',
        formatting: config.formatting,
        ...(config.rounding_decimals && {
            rounding: {
                applyRounding: true,
                decimalPoints: config.rounding_decimals,
            },
        }),
    });

    if (config.graph_metrics && config.graph_metrics.length > 0) {
        return (
            <WidgetBigNumberComparison
                title={config.widget.title}
                data={bigNumberData}
                colour={WidgetColour[widgetColor as keyof typeof WidgetColour]}
            />
        );
    }

    return <CreateAWidgetPreviewMessage message="Please select a metric to preview the big number widget" />;
};

export default WidgetPreviewBigNumberComparison;
